import { render, staticRenderFns } from "./homeComponent.vue?vue&type=template&id=5cf0797e&scoped=true"
import script from "./homeComponent.vue?vue&type=script&lang=js"
export * from "./homeComponent.vue?vue&type=script&lang=js"
import style0 from "./homeComponent.vue?vue&type=style&index=0&id=5cf0797e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf0797e",
  null
  
)

export default component.exports